import { Route, Routes } from "react-router-dom";
import AudioCallStatus from "../component/AudioCallStatus";
import AudioCallProfessional from "../pages/AudioCallProfessional";
import ChatRoom from "../pages/ChatRoom";
import ConsultantChatHistory from "../pages/Consultant/ConsultantChatHistory";
import ConsultantReview from "../pages/Consultant/ConsultantReview";
import Panchangam from "../pages/Consultant/Panchangam";
import PanchangamView from "../pages/Consultant/PanchangamView";
import CreateSlot from "../pages/Createslot";
import NoMatch from "../pages/Nopage";
import Professional from "../pages/Professional";
import ChatReceiver from "../videocall/receiver/ChatReceiver";
import VideoCallSender from "../videocall/sender/VideoCallSender";
import DataCall from "../component/DataCall";

const ProfRoute = () => {
  return (
    <Routes>
      <Route index element={<Professional />} />
      <Route exact path="startcall" element={<VideoCallSender />} />
      <Route path="chatscreen" element={<ChatRoom />} />
      <Route path="joinchat" element={<ChatReceiver />} />
      <Route exact index path="createslot" element={<CreateSlot />} />
      <Route
        exact
        index
        path="audiocallprofessional"
        element={<AudioCallProfessional />}
      />
      <Route path="audiocallstatus" element={<AudioCallStatus />} />
      <Route path="consultantChatHistory" element={<ConsultantChatHistory />} />
      <Route path="consultantreview" element={<ConsultantReview />} />
      <Route path="panchangam" element={<Panchangam />} />
      <Route path="panchangamview" element={<PanchangamView />} />
      <Route path="datacall" element={<DataCall />} />
      <Route path="*" element={<NoMatch />} />
    </Routes>
  );
};

export default ProfRoute;
